import React, { Component, Fragment,  } from 'react';

import PoDModalContainer from '../../poD/PoDModalContainer';

interface WhsPoDContainerProps {
  history: { push: Function; };
  match: { isExact: boolean; params: { awbCode: string, awbNumber: string, awbVersion: string }; path: string; url: string; };

  location: any;
};
  
interface WhsPoDContainerState {
  awbCode: string;
  awbNumber: string;
  awbVer: number;
  orderNumber: string;
  type: string;
  isModalPoDOpen: boolean;
};

class WhsPoDContainer extends Component<WhsPoDContainerProps, WhsPoDContainerState> {

  state = {
    awbCode: '',
    awbNumber: '',
    awbVer: 0,
    orderNumber: '',
    type: '',
    isModalPoDOpen: false
  }
  
  componentDidMount() {
    this.load();
    
  }

  load = () => {
    const awbNumber: string = this.props.match.params.awbNumber;
    const awbCode: string = this.props.match.params.awbCode;
    const awbVer: number = Number(this.props.match.params.awbVersion);

    if(awbCode && awbNumber) {
      this.setState({ isModalPoDOpen: true, awbCode, awbNumber, awbVer })
    }

    if(this.props.location.state) {
      const orderNumber = this.props.location.state.orderNumber;
      const type = this.props.location.state.type;
      this.setState({ orderNumber, type });
    }
  }

  gotoAwbPage = (): void => {
    this.props.history.push(`/whs/${this.state.type}/${this.state.orderNumber}`);
  }

  render() {

    return (
      
      <Fragment>
        { this.state.isModalPoDOpen && 
          <PoDModalContainer 
            isModalOpen={ this.state.isModalPoDOpen }
            handleCloseModal={ this.gotoAwbPage }
            code={ this.state.awbCode }
            number={ this.state.awbNumber }
            userRole={'whs'}
            orderNumber={ this.state.orderNumber }
            version={ this.state.awbVer }
          />
        }
      </Fragment>
    )
  }
}
  
export default WhsPoDContainer;
